<template>
  <button @click="listKPI" type="button" :class="`btn btn-sm btn-${type === 'bd' ? 'primary' : 'secondary'} mr-1`">
    <font-awesome-icon icon="bullseye" />&nbsp;{{ type === 'bd' ? $t('setupBD') : $t('setupAM') }}
    <b-modal size="xl" v-model="showList" :title="getTitle()" @ok="$emit('change')" @close="$emit('change')" ok-only
      no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                :placeholder="$t('keyword')" />
              <admin-user-select :model="filterFormModel" attribute="user"
                :placeHolder="$t(type === 'am' ? 'selectAM' : 'selectBD')"
                :roleFilter="type === 'am' ? 'am' : 'sales'" />
              <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
              <button @click="() => { reset(); load() }" class="btn btn-secondary mr-1 mb-1">Reset</button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="c-sorting"
            v-if="['owner', 'admin', 'account', 'operationsManager', 'tech'].includes($store.state.user.role)">
            <div class="row">
              <div class="col-lg-12 c-sorting__right">
                <div class="c-sorting__btn">
                  <!-- Nhập từng người một thì phòng kinh doanh vài chục người phải lặp lại vài
                       chục lượt mỗi đầu tháng -> mở bảng điền một lượt rồi lưu một lần -->
                  <button @click="openBulk" class="btn btn-sm btn-primary mr-1">
                    <font-awesome-icon icon="list" />&nbsp;{{ $t('bulkSetup') }}
                  </button>
                  <button @click="create" class="btn btn-sm btn-success">
                    <font-awesome-icon icon="plus" />&nbsp;{{ $t('create') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="c-paging clearfix">
            <div class="c-paging__count" v-if="itemCount">
              {{ $t('found', [itemCount]) }}
            </div>
            <div class="c-paging__right">
              <div class="c-paging__numbers">
                <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                  v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                  @input="load"></b-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="items.length">
          <div class="c-smart-table tile">
            <div class="row c-smart-table__title">
              <div class="col-lg-3">{{ $t('appliedTo') }}</div>
              <div class="col-lg-3">{{ $t('lastChange') }}</div>
              <div class="col-lg-2 text-right">{{ $t('amount') }}</div>
              <div class="col-lg-2 text-right">{{ $t('trialCustomer') }}</div>
              <div class="col-lg-2"></div>
            </div>
            <div class="row align-items-center" v-for="item in items" :key="item._id">
              <div class="col-lg-3">
                <span>{{ item.user.name }}</span>
                <span v-if="item.user.office" class="text-muted small ml-1">· {{ item.user.office }}</span>
              </div>
              <!-- Gộp 1 dòng: trước đây mỗi nhân viên chiếm 3-4 dòng chỉ để hiện người tạo/người
                   sửa, cả phòng kinh doanh là phải cuộn rất dài. Chi tiết đưa vào tooltip. -->
              <div class="col-lg-3 small text-muted">
                <span v-b-tooltip.hover.top="$t('createdBy') + ': ' + item.createdBy.name + ' — ' + $options.filters.moment(item.createTime, 'DD/MM/YYYY HH:mm')">
                  {{ (item.updatedBy || item.createdBy).name }},
                  {{ (item.updateTime || item.createTime) | moment('DD/MM/YYYY HH:mm') }}
                </span>
              </div>
              <div class="col-lg-2 text-right">
                <div>
                  <b class="c-smart-table__label">{{ $t('amount') }}: </b>
                  <span>{{ item.amount | numFormat }}</span>
                </div>
              </div>
              <div class="col-lg-2 text-right">
                <div>
                  <b class="c-smart-table__label">{{ $t('trialCustomer') }}: </b>
                  <span>{{ item.trialCustomerAmount | numFormat }}</span>
                </div>
              </div>
              <div class="col-lg-2 text-right">
                <div class="c-smart-table__content">
                  <div class="c-buttons clearfix is-2">
                    <div class="c-buttons__col">
                      <button @click="update(item._id)" type="button"
                        v-if="['owner', 'admin', 'account', 'operationsManager', 'tech'].includes($store.state.user.role)"
                        class="btn btn-sm btn-info mr-1">
                        <font-awesome-icon icon="edit" />&nbsp;{{ $t('edit') }}
                      </button>
                      <button @click="del(item._id)" type="button"
                        v-if="['owner', 'admin', 'account', 'operationsManager', 'tech'].includes($store.state.user.role)"
                        class="btn btn-sm btn-danger mr-1">
                        <font-awesome-icon icon="trash" />&nbsp;{{ $t('delete') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center text-danger" v-if="!items.length">
          <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
          <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
        </div>

        <div class="col-12" v-if="itemCount">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load">
          </b-pagination>
        </div>
      </div>
    
      <!-- Bảng nhập hàng loạt: liệt kê sẵn toàn bộ nhân viên, ai đã có chỉ tiêu thì điền sẵn -->
      <b-modal size="lg" v-model="showBulk" :title="$t('bulkSetup')" no-close-on-backdrop no-enforce-focus
        @ok.prevent="saveBulk">
        <div v-if="bulkLoading" class="text-center p-4"><b-spinner variant="primary"></b-spinner></div>
        <div v-else>
          <div class="alert alert-info py-2 small">{{ $t('bulkHint') }}</div>
          <!-- Phòng kinh doanh đông thì cuộn tìm từng người rất mệt: lọc theo khu vực/quyền/tên -->
          <div class="form-inline mb-2">
            <b-form-input v-model="bulkFilter.keyword" class="mr-1 mb-1" size="sm"
              :placeholder="$t('searchByName')" style="width: 180px;"></b-form-input>
            <select v-model="bulkFilter.office" class="form-control form-control-sm mr-1 mb-1" style="width: 160px;">
              <option value="">{{ $t('allRegion') }}</option>
              <option v-for="o in bulkOffices" :key="o" :value="o">{{ o }}</option>
            </select>
            <select v-model="bulkFilter.role" class="form-control form-control-sm mr-1 mb-1" style="width: 150px;">
              <option value="">{{ $t('allRole') }}</option>
              <option v-for="r in bulkRoles" :key="r" :value="r">{{ roleLabel(r) }}</option>
            </select>
            <b-form-checkbox v-model="bulkFilter.onlyNotSet" class="mr-2 mb-1">
              {{ $t('onlyNotSet') }}
            </b-form-checkbox>
            <span class="text-muted small mb-1">{{ $t('bulkShowing', [bulkVisibleRows.length, bulkRows.length]) }}</span>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-bordered mb-0">
              <thead>
                <tr>
                  <th>{{ $t('appliedTo') }}</th>
                  <th style="width: 130px;">{{ $t('region') }}</th>
                  <th class="text-right" style="width: 200px;">{{ $t('amount') }}</th>
                  <th class="text-right" style="width: 170px;">{{ $t('trialCustomer') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in bulkVisibleRows" :key="row.user">
                  <td class="align-middle">
                    {{ row.name }}
                    <span v-if="row.existed" class="badge badge-secondary ml-1">{{ $t('bulkExisted') }}</span>
                  </td>
                  <td class="align-middle small text-muted">{{ row.office || '—' }}</td>
                  <td><input type="number" min="0" class="form-control form-control-sm text-right"
                             v-model.number="row.amount"></td>
                  <td><input type="number" min="0" class="form-control form-control-sm text-right"
                             v-model.number="row.trialCustomerAmount"></td>
                </tr>
                <tr v-if="!bulkVisibleRows.length">
                  <td colspan="4" class="text-center text-danger">{{ $t('noData') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-modal>
</b-modal>
    <b-modal v-model="showForm" :title="''" @ok="save" no-close-on-backdrop no-enforce-focus>
      <admin-user-select :label="$t(type)" :model="formModel" attribute="user" :multiple="false"
        :placeHolder="$t(type === 'am' ? 'selectAM' : 'selectBD')" :roleFilter="type === 'am' ? 'am' : 'sales'"
        :errors="formErrors" />
      <form-input :label="$t('amount')" :model="formModel" attribute="amount" :errors="formErrors" />
      <form-input :label="$t('trialCustomer')" :model="formModel" attribute="trialCustomerAmount"
        :errors="formErrors" />
    </b-modal>
  </button>
</template>

<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import AdminUserSelect from "@/components/AdminUserSelect";

export default {
  components: { AdminUserSelect },
  props: ['kpi', 'type'],
  mixins: [List, CRUD],
  data() {
    return {
      showList: false,
      showBulk: false,
      bulkLoading: false,
      bulkRows: [],
      bulkFilter: {keyword: '', office: '', role: '', onlyNotSet: false},
      autoLoad: false,
      service: 'admin-user-kpi-item',
      defaultFormModel: {
        kpi: this.kpi._id,
        type: this.type,
        user: null,
        amount: 0,
        trialCustomerAmount: 0
      },
      defaultFilterFormModel: {
        kpi: this.kpi._id,
        type: this.type
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: "Setup {0} Kpi {1}",
        bd: "BD",
        am: "AM",
        setupBD: "Setup BD",
        bulkSetup: "Bulk entry",
        noData: "No data",
        roleSales: "Sales",
        roleKpiSales: "Sales (KPI)",
        roleCtvSales: "Sales collaborator",
        lastChange: "Last change",
        region: "Region",
        allRegion: "All regions",
        allRole: "All roles",
        searchByName: "Search by name",
        onlyNotSet: "Not set yet only",
        bulkShowing: "Showing {0}/{1} staff",
        bulkHint: "Fill in targets for the staff you need, then save once. Staff with no target yet are skipped if left at 0. Rows marked \"already set\" are always updated — leaving 0 sets their target to 0.",
        bulkExisted: "already set",
        bulkSaved: "Saved targets for {0} staff",
        bulkNothingToSave: "No target entered yet",
        somethingWentWrong: "Something went wrong, please try again",
        setupAM: "Setup AM",
        month: 'Month',
        year: 'Year',
        selectAM: "Select AM",
        selectBD: "Select BD",
        amount: "Revenue",
        trialCustomer: "Trial customers",
        appliedTo: "Applied to",
        createdBy: "Created by",
        createdAt: "Created at",
        updatedBy: "Updated by",
        updatedAt: "Updated at",
      },
      vi: {
        title: "Cài đặt {0} Kpi tháng {1}",
        bd: "BD",
        am: "AM",
        setupBD: "Cài đặt BD",
        bulkSetup: "Nhập hàng loạt",
        noData: "Không có dữ liệu",
        roleSales: "Nhân viên kinh doanh",
        roleKpiSales: "Kinh doanh (KPI)",
        roleCtvSales: "Cộng tác viên kinh doanh",
        lastChange: "Thay đổi gần nhất",
        region: "Khu vực",
        allRegion: "Tất cả khu vực",
        allRole: "Tất cả quyền",
        searchByName: "Tìm theo tên",
        onlyNotSet: "Chỉ người chưa đặt",
        bulkShowing: "Hiện {0}/{1} nhân viên",
        bulkHint: "Điền chỉ tiêu cho những nhân viên cần đặt rồi lưu một lần. Người chưa có chỉ tiêu mà để 0 thì bỏ qua. Người đã ghi \"đã đặt\" thì luôn được cập nhật, để 0 nghĩa là hạ chỉ tiêu về 0.",
        bulkExisted: "đã đặt",
        bulkSaved: "Đã lưu chỉ tiêu cho {0} nhân viên",
        bulkNothingToSave: "Chưa nhập chỉ tiêu nào",
        somethingWentWrong: "Có lỗi xảy ra, vui lòng thử lại",
        setupAM: "Cài đặt AM",
        month: 'Tháng',
        year: 'Năm',
        selectAM: "Chọn AM",
        selectBD: "Chọn nhân viên kinh doanh",
        amount: "Doanh thu",
        trialCustomer: "Số khách hàng dùng thử",
        appliedTo: "Áp dụng cho",
        createdBy: "Tạo bởi",
        createdAt: "Tạo lúc",
        updatedBy: "Cập nhật bởi",
        updatedAt: "Cập nhật lúc",
      }
    }
  },
  computed: {
    bulkOffices() {
      return [...new Set(this.bulkRows.map(r => r.office).filter(Boolean))].sort();
    },
    bulkRoles() {
      return [...new Set(this.bulkRows.map(r => r.role).filter(Boolean))].sort();
    },
    bulkVisibleRows() {
      const f = this.bulkFilter;
      const kw = (f.keyword || '').trim().toLowerCase();
      return this.bulkRows.filter(r => {
        if (kw && !(r.name || '').toLowerCase().includes(kw)) return false;
        if (f.office && r.office !== f.office) return false;
        if (f.role && r.role !== f.role) return false;
        if (f.onlyNotSet && r.existed) return false;
        return true;
      });
    },
  },
  methods: {
    roleLabel(r) {
      const map = {sales: this.$t('roleSales'), kpiSales: this.$t('roleKpiSales'), ctvSales: this.$t('roleCtvSales'), am: 'AM'};
      return map[r] || r;
    },
    // Mở bảng nhập hàng loạt: lấy toàn bộ nhân viên đúng vai trò, ghép sẵn chỉ tiêu đã có
    openBulk: async function () {
      this.showBulk = true;
      this.bulkLoading = true;
      this.bulkRows = [];
      this.bulkFilter = {keyword: '', office: '', role: '', onlyNotSet: false};
      try {
        // /admin-user nhận nhiều vai trò cách nhau dấu phẩy. Chỉ lấy mỗi 'sales' thì ô lọc
        // quyền luôn có đúng 1 lựa chọn, lọc vô nghĩa.
        const role = this.type === 'am' ? 'am' : 'sales,kpiSales,ctvSales';
        const [usersRes, itemsRes] = await Promise.all([
          this.$service.get('/admin-user', {params: {page: 1, pageSize: 500, role: role, status: 0}}),
          this.$service.get('/' + this.service, {params: {page: 1, pageSize: 500, kpi: this.kpi._id, type: this.type}}),
        ]);
        const existed = {};
        ((itemsRes.data && itemsRes.data.docs) || []).forEach(it => {
          if (it.user) existed[it.user._id || it.user] = it;
        });
        this.bulkRows = ((usersRes.data && usersRes.data.docs) || []).map(u => {
          const cur = existed[u._id];
          return {
            user: u._id,
            name: u.name,
            office: u.office || '',
            role: u.role || '',
            amount: cur ? (cur.amount || 0) : 0,
            trialCustomerAmount: cur ? (cur.trialCustomerAmount || 0) : 0,
            existed: !!cur,
          };
        });
      } catch (e) {
        this.$swal({text: this.$t('somethingWentWrong'), icon: 'error'});
        this.showBulk = false;
      } finally {
        this.bulkLoading = false;
      }
    },
    saveBulk: function () {
      // Chỉ gửi dòng có nhập số, khỏi tạo hàng loạt bản ghi 0 vô nghĩa cho người không có chỉ tiêu
      // Dòng đã có chỉ tiêu thì luôn gửi, kể cả khi để 0 — nếu không, hạ chỉ tiêu ai đó về 0
      // sẽ bị loại khỏi payload, số cũ giữ nguyên mà màn hình vẫn báo "đã lưu".
      // Dòng chưa có chỉ tiêu mà để 0 thì bỏ qua, khỏi tạo hàng loạt bản ghi 0 vô nghĩa.
      const items = this.bulkRows
        .filter(r => r.existed || (r.amount || 0) > 0 || (r.trialCustomerAmount || 0) > 0)
        .map(r => ({user: r.user, amount: r.amount || 0, trialCustomerAmount: r.trialCustomerAmount || 0}));
      if (!items.length) {
        this.$swal({text: this.$t('bulkNothingToSave'), icon: 'warning'});
        return;
      }
      let loader = this.$loading.show();
      this.$service.post('/' + this.service + '/bulk', {kpi: this.kpi._id, type: this.type, items: items})
        .then(res => {
          const n = (res.data && res.data.saved) || items.length;
          this.$swal({text: this.$t('bulkSaved', [n]), icon: 'success', toast: true, position: 'top-end', timer: 4000});
          this.showBulk = false;
          this.load();
          this.$emit('change');
        })
        .catch(error => {
          const data = error.response ? error.response.data : null;
          this.$swal({text: (data && data.message) || this.$t('somethingWentWrong'), icon: 'error'});
        })
        .finally(() => loader.hide());
    },
    getTitle() {
      return this.$t('title',
        [
          this.$t(this.type),
          (this.kpi.month < 10 ? '0' + this.kpi.month : this.kpi.month) + '-' + this.kpi.year
        ]
      );
    },
    listKPI() {
      this.showList = true;
      this.load();
    },
  }
}
</script>